export const extractSectorName = (key) => {
    return key.split(';;')[0]
}
